// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"8427ff0d","284":"077b062b","299":"9c0f2d96","453":"820f37b7","964":"a3eca20a","981":"e7581760"}[chunkId] + ".chunk.js";
};